import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import api from "@/components/axios";
import { getUrlKey } from "@/utils/common.js";
import { Toast } from "vant";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("./view/index.vue"),
    meta: {
      title: "密封技术",
      keepAlive: true,
      isPublic: true,
    },
  },
  {
    path: "/info",
    name: "info",
    component: () => import("./view/info.vue"),
    meta: {
      title: "密封技术",
      keepAlive: false,
      isPublic: true,
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("./view/contact.vue"),
    meta: {
      title: "密封技术",
      keepAlive: false,
      isPublic: true,
    },
  },
  {
    path: "/result",
    name: "result",
    component: () => import("./view/result.vue"),
    meta: {
      title: "密封技术",
      keepAlive: false,
      isPublic: true,
    },
  },
  {
    path: "/trial",
    name: "trial",
    component: () => import("./view/trial.vue"),
    meta: {
      title: "0元试用",
      keepAlive: false,
      isPublic: true,
    },
  },
  {
    path: "/trial-result",
    name: "trial-result",
    component: () => import("./view/trial-result.vue"),
    meta: {
      title: "0元试用",
      keepAlive: false,
      isPublic: true,
    },
  },
  {
    path: "/other",
    name: "buyOther",
    component: () => import("./view/other.vue"),
    meta: {
      title: "密封询价",
      keepAlive: false,
      isPublic: false,
    },
  },
  {
    path: "/other-result",
    name: "other-result",
    component: () => import("./view/other-result.vue"),
    meta: {
      title: "提交成功",
      keepAlive: false,
      isPublic: true,
    },
  },
  {
    path: "/mrod",
    name: "buyMrod",
    component: () => import("./view/mrod.vue"),
    meta: {
      title: "旋转油封选型器",
      keepAlive: false,
      isPublic: false,
    },
  },
  {
    path: "/my-order",
    name: "my-order",
    component: () => import("./view/my-order.vue"),
    meta: {
      title: "我的订单",
      keepAlive: false,
    },
  },
  {
    path: "/oring",
    name: "oring",
    component: () => import("./view/oring.vue"),
    meta: {
      title: "O形圈选型器",
      keepAlive: false,
      isPublic: false,
    },
  },
  {
    path: "/shopping-cart",
    name: "shopping-cart",
    component: () => import("./view/shopping-cart.vue"),
    meta: {
      title: "进货单",
      keepAlive: false,
    },
  },
  {
    path: "/cart-result",
    name: "cart-result",
    component: () => import("./view/cart-result.vue"),
    meta: {
      title: "下单成功",
      keepAlive: false,
    },
  },
  {
    path: "/order-detail/:id",
    name: "order-detail",
    component: () => import("./view/order-detail.vue"),
    meta: {
      title: "订单详情",
      keepAlive: false,
    },
  },
  {
    path: "/address-list",
    name: "address-list",
    component: () => import("./view/address-list.vue"),
    meta: {
      title: "我的地址",
      keepAlive: false,
    },
  },
  {
    path: "/address-create",
    name: "address-create",
    component: () => import("./view/address-edit.vue"),
    meta: {
      title: "新建地址",
      keepAlive: false,
    },
  },
  {
    path: "/address-edit/:id",
    name: "address-edit",
    component: () => import("./view/address-edit.vue"),
    meta: {
      title: "编辑地址",
      keepAlive: false,
    },
    props: true,
  },
  {
    path: "/invoice-list",
    name: "invoice-list",
    component: () => import("./view/invoice-list.vue"),
    meta: {
      title: "我的发票",
      keepAlive: false,
    },
  },
  {
    path: "/invoice-create",
    name: "invoice-create",
    component: () => import("./view/invoice-edit.vue"),
    meta: {
      title: "新建发票",
      keepAlive: false,
    },
    props: true,
  },
  {
    path: "/invoice-edit/:id",
    name: "invoice-edit",
    component: () => import("./view/invoice-edit.vue"),
    meta: {
      title: "编辑发票",
      keepAlive: false,
    },
    props: true,
  },
  {
    path: "/invoice-info",
    name: "invoice-info",
    component: () => import("./view/invoice-info.vue"),
    meta: {
      title: "申请发票",
      keepAlive: false,
    },
  },
];

routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (!to.meta.isPublic) {
    const token = window.$cookies.get("token");
    // 获取登录URL
    const url = encodeURIComponent(window.location.origin + window.location.pathname);
    const code = getUrlKey("code");
    const accessToken = getUrlKey("accessToken");

    if (code) {
      const ssoCode = window.$cookies.get("ssoCode");
      // h5，根据code获取用户信息
      if (ssoCode && ssoCode == code && token) {
        next();
      } else {
        window.$cookies.set("ssoCode", code);
        Toast.loading({
          message: "登录中...",
          forbidClick: true,
          duration: 0,
        });
        api.get(`/sso/user_info/code?code=${code}&redirectUrl=${url}`).then((res) => {
          Toast.clear();
          if (res.data.code === 200) {
            const { jwt } = res.data.data;
            window.$cookies.set("token", jwt.token, jwt.expire / 1000);
            window.$cookies.set("phone", res.data.data.mobile, jwt.expire / 1000);
            store.dispatch("getCartList");
            next();
          } else {
            Toast.fail("登录失败！");
            next(false);
          }
        });
      }
    } else if (accessToken) {
      const ssoAccessToken = window.$cookies.get("ssoAccessToken");
      // 微信小程序，根据access_token获取用户信息
      if (ssoAccessToken && ssoAccessToken == accessToken && token) {
        next();
      } else {
        window.$cookies.set("ssoAccessToken", accessToken);
        Toast.loading({
          message: "登录中...",
          forbidClick: true,
          duration: 0,
        });
        api.get("/sso/user_info/access_token?accessToken=" + accessToken).then((res) => {
          Toast.clear();
          if (res.data.code === 200) {
            const { jwt } = res.data.data;
            window.$cookies.set("token", jwt.token, jwt.expire / 1000);
            window.$cookies.set("phone", res.data.data.mobile, jwt.expire / 1000);
            store.dispatch("getCartList");
            next();
          } else {
            Toast.fail("登录失败！");
            next(false);
          }
        });
      }
    } else if (!token) {
      api.get("/sso/login_url?redirectUrl=" + url).then((res) => {
        if (res.data.code === 200) {
          // 跳转到sso登录页
          window.location.href = res.data.data;
        } else {
          Toast.fail("跳转登录页失败！");
          next(false);
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export { router };
